import { RouterProvider } from "react-router-dom";
import appRouter from "./routes/main";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { VITE_GOOGLE_OAUTH_CLIENT_ID } from "./config/config";
import { useEffect } from "react";
import { initialiseAmplitude } from "./amplitude/amplitude";

function App() {
  useEffect(() => {
    initialiseAmplitude();
  }, []);

  return (
    <GoogleOAuthProvider clientId={VITE_GOOGLE_OAUTH_CLIENT_ID}>
      {
        <>
          <RouterProvider router={appRouter} />
        </>
      }
    </GoogleOAuthProvider>
  );
}

export default App;
